import { TitleH2 } from './Title'

export { TitleH2 }
